module.exports = __webpack_public_path__ + "assets/events_threat_white.d76ebb36.svg";